import { ApiLaydownLogRow } from "./ApiLaydownLogRow";
export class LaydownLogRow {
    id?: number;
    jobNumber?: string;
    contact?: string;
    space?: string;
    dateIn?: string;
    estDuration?: number;
    estDateOut?: string;
    dateOut?: string;
    loggedBy?: string;
    storageFacility?: string;
    loggedAt?: string;
  
    public constructor(init?: Partial<LaydownLogRow>) {
      if (init) {
        // Safely assign properties to this instance
        Object.assign(this, init);
  
        // Convert Date objects to strings in the MM/DD/YYYY format
        if (init.dateIn) {
        const realDateIn = new Date(init.dateIn);
          this.dateIn = realDateIn.toLocaleDateString('en-US',
           { year: '2-digit',  // Two-digit year
            month: '2-digit', // Two-digit month
            day: '2-digit'    // Two-digit day
          });
        }
         
        if (init.dateOut) {
          const realDateOut = new Date(init.dateOut);
            this.dateOut = realDateOut.toLocaleDateString('en-US',
             { year: '2-digit',  // Two-digit year
              month: '2-digit', // Two-digit month
              day: '2-digit'    // Two-digit day
            });
        }

        if (init.estDateOut) {
          const realEstDateOut = new Date(init.estDateOut);
            this.estDateOut = realEstDateOut.toLocaleDateString('en-US',
             { year: '2-digit',  // Two-digit year
              month: '2-digit', // Two-digit month
              day: '2-digit'    // Two-digit day
            });
        }


      }
    }
  }
  